export const formatReferenceNumber = (ref: string, isTemporary?: boolean) => {
  return ref.replace(/^([^\d]+)(\d+)$/, (_, letters, numbers) =>
    isTemporary ? `${letters}T${numbers}` : `${letters}${numbers}`
  );
};